import Controller from '@ember/controller';
import { service } from '@ember/service';

import { isDevelopingApp, macroCondition } from '@embroider/macros';
import { ToastRegion } from '@repo/design-system-kit';

import ENV from 'receivable-invoices-js/config/environment';

import styles from './styles.module.css';

export default class ApplicationController extends Controller {
  @service flashMessages;

  toastRegion = ToastRegion;

  constructor() {
    super(...arguments);
    if (macroCondition(isDevelopingApp())) {
      document.title = 'Qonto - dev';
    } else {
      // eslint-disable-next-line no-console
      console.log('app version:', ENV.qontoAppVersion);
    }
  }
  styles = styles;
}
